<template>
  <LayoutGradient :title="$t('dexpara.ordem.titulo_pagina')" icon="fa-random" :content-overflow="false">
    <b-card-group class="m-3 mt-n10 bg-transparent border-0" body-class="p-0" deck>
      <b-card class="col-md-9" body-class="p-0">
        <DeXParaFilter @search="searchExams(true)"/>

        <TableSimple
            :fields="fields"
            :items="exams"
            :loading="examsIsLoading || DeXParaIsLoading"
            :paginator="examsPagination"
            :text-empty="$t('dexpara.ordem.exams.empty')"
            thead-class="h5 text-center"
            @paginate="paginateExams"
            borderless
            marginless
            hover
        >
          <template v-slot:cell(origin)="linha">
            <form-group-float-label
                :label="linha.item.name"
                :input-name="`input-origem-${linha.index}`"
                :disabled="!integrationsSelected.origin"
                v-model="linha.item.origin_code"
                mandatory
            />
            <b-button size="sm" variant="link" @click="openDetails(linha);">
              {{ $t('dexpara.filtros.detalhes') }}
            </b-button>
            <b-button size="sm" variant="link" @click="openLogs(linha);" v-if="permissions.includes('logs.detail')">
              {{ $t('dexpara.filtros.logs') }}
            </b-button>
          </template>

          <template v-slot:cell(destination)="{index, item}">
            <form-group-float-label
                :label="item.name"
                :input-name="`input-destino-${index}`"
                :disabled="!integrationsSelected.destination"
                v-model="item.destination_code"
                mandatory
            />
          </template>

          <template #row-details="{ item, index }">
            <b-table stacked :fields="details" :items="formatExamDetails(item)" v-show="showDetails[index]" />
            <div v-show="showLogs[index]">
              <b-card :title="$t('dexpara.log.origem')">
                <b-card-text v-if="logItems[index] && logItems[index].logOrigin">
                  {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logOrigin.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logOrigin.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logOrigin" class="btn btn-outline-info" @click="openHistory(logItems[index].logOrigin.auditable_id)">Ver Histórico</button>
              </b-card>
              <b-card :title="$t('dexpara.log.destino')" class="mt-2">
                <b-card-text v-if="logItems[index] && logItems[index].logDestination">
                  {{ $t('dexpara.log.ultimo.info') }} {{logItems[index].logDestination.user_name}} {{ $t('dexpara.log.ultimo.complemento') }} {{formatDate(logItems[index].logDestination.updated_at)}}.
                </b-card-text>
                <b-card-text v-else>{{ $t('dexpara.log.vazio') }}</b-card-text>
                <button v-if="logItems[index] && logItems[index].logDestination" class="btn btn-outline-info" @click="openHistory(logItems[index].logDestination.auditable_id)">Ver Histórico</button>
              </b-card>
            </div>
          </template>          
        </TableSimple>
      </b-card>

      <DeXParaIntegrationsCopy class="col-md-3 sticky-top h-100" @change="updateIntegrations" @save="persistDeXPara" @save-copy="(evt) => persistDeXParaCopy(evt)"/>

    </b-card-group>
  </LayoutGradient>
</template>

<script>
import {hasPerfil, getPermissionsFromActualPerfil} from '@/acl';
import DeXParaFilter from "@/pages/dexpara/components/DeXParaFilter";
import LayoutGradient from "@/templates/LayoutGradient";
import {mapActions, mapGetters} from 'vuex';
import TableSimple from "@/components/TableSimple";
import FormGroupFloatLabel from "@/components/FormGroupFloatLabel";
import DeXParaIntegrationsCopy from "@/pages/dexpara/components/DeXParaIntegrationsCopy";
import DeXParaRepository from "@/repositories/dexpara/OrderRepository";
import AuditRepository from "@/repositories/audit/AuditRepository";
import moment from "moment";

export default {
  name: "DeXParaOrdem",
  components: {
    DeXParaIntegrationsCopy,
    TableSimple,
    FormGroupFloatLabel,
    DeXParaFilter,
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      filters: 'dexpara/filters',
      exams: 'tuevs/exams/all',
      examsIsLoading: 'tuevs/exams/isLoading',
      examsPagination: 'tuevs/exams/pagination',
      deXparas: 'dexpara/order/all',
      DeXParaIsLoading: 'dexpara/order/isLoading',
      examsByType: 'tuevs/exams/allByType',
    })
  },
  data() {
    return {
      integrationsSelected: {
        origin: null,
        destination: null
      },
      copySelected: {
        integration_type: null,
        integration_to: null
      },
      fields: [
        {key: 'origin', label: this.$t('dexpara.ordem.exams.origem'), tdClass: 'w-50'},
        {key: 'destination', label: this.$t('dexpara.ordem.exams.destino'), tdClass: 'w-50'}
      ],
      details: [
        {key: 'component', label: this.$t('dexpara.filtros.componente')},
        {key: 'specimen', label: this.$t('dexpara.filtros.material')},
        {key: 'methods', label: this.$t('dexpara.filtros.metodos')},
        {key: 'scale', label: this.$t('dexpara.filtros.escala')},
        {key: 'time', label: this.$t('dexpara.filtros.tempos')}
      ],
      showDetails: [],
      showLogs: [],
      logItems: [],
      permissions: [],
      canAccessRoot: false
    }
  },
  methods: {
    ...mapActions([
      'integration/search',
      'dexpara/order/listAll',
      'tuevs/exams/listAll',
      'tuevs/exams/findByType'
    ]),
    openDetails(linha) {
      if (!this.showDetails[linha.index] || this.showDetails[linha.index] === false) {
        if (linha.detailsShowing === true && this.showLogs[linha.index] === true) {
          linha.toggleDetails();
        }
        
        this.showLogs[linha.index] = false;
        this.showDetails[linha.index] = true;
        linha.toggleDetails();
        return;
      }

      if (this.showDetails[linha.index] === true) {
        this.showLogs[linha.index] = false;
        this.showDetails[linha.index] = false;
        linha.toggleDetails();
        return;
      }
    },
    async openLogs(linha) {
      if (!this.showLogs[linha.index] || this.showLogs[linha.index] === false) {
        this.logItems[linha.index] = await this.formatLogDetails(linha.item);        
        
        if (linha.detailsShowing === true && this.showDetails[linha.index] === true) {          
         linha.toggleDetails();
        }

        this.showDetails[linha.index] = false;
        this.showLogs[linha.index] = true;
        linha.toggleDetails();
        return;
      }      

      if (this.showLogs[linha.index] === true) {
        this.showDetails[linha.index] = false;
        this.showLogs[linha.index] = false;
        linha.toggleDetails();
        return;
      }
    },
    formatExamDetails(exam) {
      let obj = {}
      if (exam.component && exam.component.name) {
        obj.component = exam.component.name
      }
      if (exam.methods) {
        obj.methods = exam.methods.map(m => m.name).join(', ')
      }
      if (exam.scale && exam.scale.name) {
        obj.scale = exam.scale.name
      }
      if (exam.specimen && exam.specimen.name) {
        obj.specimen = exam.specimen.name
      }
      if (exam.time && exam.time.name) {
        obj.time = exam.time.name
      }
      return [obj]
    },
    async formatLogDetails(exam) {
      let obj = {}
      let logOrigin = null
      let logDestination = null
      if (!this.deXparas || this.deXparas.length === 0) {
        return obj
      }

      let originMapped = this.deXparas.filter(d => d.tuevs_exam_id === exam.id && d.code === exam.origin_code);
      let destinationMapped = this.deXparas.filter(d => d.tuevs_exam_id === exam.id && d.code === exam.destination_code);

      if (originMapped && originMapped.length > 0) {
        logOrigin = await AuditRepository.getLastByModelId(originMapped[0].id).then(async (response) => {          
          return response.data.data;          
        })
      }

      if (destinationMapped && destinationMapped.length > 0) {
        logDestination = await AuditRepository.getLastByModelId(destinationMapped[0].id).then(async (response) => {          
          return response.data.data;
        })
      }

      obj.logOrigin = logOrigin;
      obj.logDestination = logDestination;
      return obj
    },
    openHistory(auditId) {
      const routeData = this.$router.resolve({ name: 'logs.detail', params: { id: auditId } });
      window.open(routeData.href, '_blank');
    },
    formatDate(date) {
      return moment(String(date)).format('DD/MM/YYYY HH:mm:ss');
    },
    async paginateExams(pagination) {
      await this.$store.commit('tuevs/exams/setPagination', {
        ...this.examsPagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.searchExams()
    },
    async searchExams(isFilter = false) {
      let filterApi = [...this.filters];
      let hasIntegrationFilter = filterApi.some(f => f[0] === "integration");
      let hasCodeFilter = filterApi.some(f => f[0] === "code");

      if (!hasIntegrationFilter && hasCodeFilter) {
        if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
          filterApi.push(['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]);
        }
      }

      if (isFilter) {
        await this['tuevs/exams/listAll']({
          ...this.examsPagination,
          page: 1,
          exam_type: 'order',
          filters: filterApi
        })
      } else {
        await this['tuevs/exams/listAll']({
          ...this.examsPagination,
          exam_type: 'order',
          filters: filterApi
        })
      }

      this.showDetails = []
      this.showLogs = []
      this.logItems = []

      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async searchDeXparas() {
      let filters = [
        ['tuevs_exam_id', 'IN', this.exams.reduce((acc, current) => [...acc, current.id], [])],
        ['integration', 'IN', [this.integrationsSelected.origin, this.integrationsSelected.destination]]
      ]
      if (this.integrationsSelected.origin || this.integrationsSelected.destination) {
        await this['dexpara/order/listAll']({
          per_page: this.examsPagination.per_page * 2,
          filters: JSON.stringify(filters)
        })
      }
    },
    getDeXpara(tuevs_exam_id, integration_id) {
      if (this.deXparas && Array.isArray(this.deXparas)) {
        return this.deXparas.find(exam => {
          return exam.vns_integration_id === integration_id && exam.tuevs_exam_id === tuevs_exam_id
        })
      }
      return null
    },
    async loadIntegrationsCodes() {
      if (this.exams && Array.isArray(this.exams)) {
        const exams = this.exams.map(exam => {
          const origin_mapped = this.getDeXpara(exam.id, this.integrationsSelected.origin)
          exam.origin_code = origin_mapped && origin_mapped.code ? origin_mapped.code : null

          const destination_mapped = this.getDeXpara(exam.id, this.integrationsSelected.destination)
          exam.destination_code = destination_mapped && destination_mapped.code ? destination_mapped.code : null

          return exam
        })
        this.$store.commit('tuevs/exams/setAll', exams)
      }
    },
    async updateIntegrations(evt) {
      this.integrationsSelected.origin = this.integrationsSelected.destination = null

      let originLabel = this.$t('dexpara.ordem.exams.origem')
      if (evt.origin) {
        originLabel = evt.origin.label
        this.integrationsSelected.origin = evt.origin.value
      }

      let destinationLabel = this.$t('dexpara.ordem.exams.destino')
      if (evt.destination) {
        destinationLabel = evt.destination.label
        this.integrationsSelected.destination = evt.destination.value
      }

      this.fields = [{key: 'origin', label: originLabel}, {key: 'destination', label: destinationLabel}]
      await this.searchDeXparas()
      await this.loadIntegrationsCodes()
    },
    async persistDeXParaCopy(evt) {
      this.copySelected = evt;

      if (this.copySelected.integration_type === null || this.copySelected.integration_to === null) {
          this.$snotify.error(this.$t('dexpara.copia.erro.vazio'))
          return;
      }

      if (this.copySelected.integration_type.value === 'origin' && !this.integrationsSelected.origin) {          
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_origem'))
          return;
      }

      if (this.copySelected.integration_type.value === 'destiny' && !this.integrationsSelected.destination) {
          this.$snotify.error(this.$t('dexpara.copia.erro.integracao_destino'))
          return;
      }

      this.$snotify.clear()
      this.$snotify.confirm(
          this.$t('dexpara.copia.confirmacao.mensagem'),
          this.$t('dexpara.copia.confirmacao.titulo'),
          {
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            buttons: [
              {
                text: this.$t('dexpara.copia.sim'),
                action: async toast => {
                  this.$snotify.remove(toast.id)
                  if (this.filters.length > 0) {
                    await this['tuevs/exams/findByType']({        
                      exam_type: 'order',
                      filters: this.filters
                    })
                  }

                  let filterExams = [
                    ['tuevs_exam_id', 'IN', this.examsByType.reduce((acc, current) => [...acc, current.id], [])]
                  ]
                  
                  await DeXParaRepository.postCopy(
                    {
                      copy: this.copySelected,
                      integrations: this.integrationsSelected,          
                      exams: filterExams
                    }
                  ).then(async () => {
                    this.$snotify.success(this.$t('dexpara.copia.sucesso'))
                  }).catch(error => {
                    this.$snotify.error(this.$t('dexpara.copia.erro.copiar'))
                  })
                },
                bold: true
              },
              {
                text: this.$t('dexpara.copia.nao'),
                action: toast => {
                  this.$snotify.remove(toast.id)
                },
                bold: true
              }
            ]
          }
      )
    },
    async persistDeXPara() {
      let parsedIntegrations = []

      if (this.integrationsSelected.origin) {
        let integrationId = this.integrationsSelected.origin
        this.exams.filter(e => e.origin_code !== null)
            .map(exam => {
              let dexpara = {tuevs_exam_id: exam.id, integrations: [{id: integrationId, code: exam.origin_code}]}
              if (this.getDeXpara(exam.id, integrationId) && exam.origin_code === '') {
                dexpara = {...dexpara, delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (this.integrationsSelected.destination) {
        let integrationId = this.integrationsSelected.destination
        this.exams.filter(e => e.destination_code !== null)
            .map(exam => {
              let dexpara = {tuevs_exam_id: exam.id, integrations: [{id: integrationId, code: exam.destination_code}]}
              if (this.getDeXpara(exam.id, integrationId) && exam.destination_code === '') {
                dexpara = {...dexpara, delete: true}
              }
              parsedIntegrations.push(dexpara)
            })
      }

      if (parsedIntegrations.length > 0) {
        await DeXParaRepository.post({exams: parsedIntegrations}).then(async () => {
          await this['dexpara/order/listAll']()
          this.$snotify.success(this.$t('dexpara.ordem.exams.sucesso'))
          await this.searchExams()
        })
      }
    }
  },
  async beforeMount() {
    this.permissions = await getPermissionsFromActualPerfil();
    this.canAccessRoot = await hasPerfil('root');
  },
  async mounted() {
    this.$store.commit('tuevs/exams/setPagination', {...this.examsPagination, page: 1})
    this['tuevs/exams/listAll']({exam_type: 'order', filters: this.filters, ...this.examsPagination})
    this['integration/search']()
  }
}
</script>

<style lang="scss" scoped>
.sticky-top {
  top: 1.5rem;

  @media only screen and(max-width: 768px) {
    order: -1;
  }
}
</style>
